/*eslint-disable*/
import React from "react";
import {isMobile} from 'react-device-detect';

function ContatoHeader() {
  return (
    <>
      <div style={{marginTop: 70}}>
        <div className="">
        {
            isMobile ? 
              window.innerWidth < 600 ? 
              (
                <img
                    alt="header-home"
                    src={require("assets/img/capa-contato-mobile.png")}
                ></img>
              ) : (
                <img
                    alt="header-home"
                    src={require("assets/img/capa-contato-1024.jpg")}
                ></img>
              )
            : (
              <img
                  alt="header-home"
                  src={require("assets/img/capa-contatos.jpg")}
              ></img>
            )
          }
        </div>
      </div>
    </>
  );
}

export default ContatoHeader;